import { Link, Stack, Typography } from "@mui/material";
import { logout } from "../app/auth";

export interface ApiResultAlertProps {
  title?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
}

export const ApiResultAlert = (props: ApiResultAlertProps) => {
  const { title, error } = props;
  const errorData = error?.data;
  const errors = error?.data?.errors;
  const status = errorData?.status ?? error?.originalStatus;
  let errorTitle = "";
  if (typeof errorData === "string") {
    errorTitle = `HTTP ${status}: ${errorData}`;
  } else if (typeof errorData === "object") {
    errorTitle = `HTTP ${status}: ${errorData?.title}`;
  } else if (title) {
    errorTitle = title;
  }

  const handleLogout = () => {
    logout();
  };

  return (
    <Stack>
      <Typography variant="body1">{errorTitle}</Typography>
      {errors && (
        <ul style={{ paddingLeft: 0 }}>
          {Object.keys(errors).map((key) => {
            return (
              <Typography key={key} variant="body2">
                {key}: {errors[key]}
              </Typography>
            );
          })}
        </ul>
      )}
      {status === 401 && (
        <Link onClick={handleLogout} underline="hover" color="error" sx={{ cursor: "pointer" }}>
          Log out and back again
        </Link>
      )}
    </Stack>
  );
};
